import React from "react";
import style from "./CustomSelect.module.css";

interface selectType {
  onChange: (e: any) => void;
  id: string;
  name: string;
  styleSelect: any;
  styleLabel?: any;
  styleContainer: any;
  labelText?: string;
  errorText?: string;
  optionsArray: string[];
  defaultValue?: string;
}

function CustomSelect(props: selectType) {
  return (
    <div className={props.styleContainer} style={{ position: "relative" }}>
      <select
        className={props.styleSelect}
        name={props.name}
        id={props.id}
        onChange={props.onChange}
        defaultValue={props.defaultValue}
      >
        {props.optionsArray.map((option, ind) => {
          return (
            <option key={ind} value={option}>
              {option}
            </option>
          );
        })}
      </select>
      <span className={style.arrowDown}></span>
    </div>
  );
}

export default CustomSelect;
